import {Fragment, useEffect, useState} from "react";
import {
  Box,
  Button, Chip, CircularProgress,
  Dialog, DialogActions, DialogContent, DialogContentText, Menu, MenuItem,
  Paper, Snackbar, TextField, Typography,
} from "@mui/material";

import {Link, useHistory} from "react-router-dom";
import {MobileDateTimePicker} from "@mui/lab";
import CurrencyInput from "react-currency-input-field";
import styled from "@emotion/styled";
import moment from "moment";
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "../constant";
import {Alert, ProgressDiv} from "../styles";
import {ArrowDropDownOutlined} from "@mui/icons-material";
import {useUserState} from "../UserContext";
import {getWarehouseNameFromState} from "../stringutils";
import {useWarehouseState} from "../WarehouseContext";
import {getBuyCond} from "../osp_utils";

export const CurrencyTextField = styled(CurrencyInput)(({ theme }) => ({
  fontSize : 16,
  paddingTop : 18,
  paddingBottom : 18,
  paddingLeft : 12,
  color : theme.palette.text.primary,
  outlineColor : theme.palette.text.primary,
  borderColor : '#00000046',
  borderWidth : 1,
  borderRadius : 4,
}));


export function BuyDetail(props) {
  const history = useHistory()
  const warehouseState = useWarehouseState()
  const [requesting, setRequesting] = useState(false)
  const [buy, setBuy] = useState(null)
  const [buyDialog, setBuyDialog] = useState({
    open : false,
    date : new Date(),
    priceTotal : null,
    buyAvailable : false,
    priceError : '',
    cardError : '',
    selectCardAvailable : true,
  })


  const userState = useUserState()
  const [cardMenuAnchorEl, setCardMenuAnchorEl] = useState(null)

  const [cardName, setCardName] = useState(null)
  const cardMenuOpen = Boolean(cardMenuAnchorEl)
  const [snackbar, setSnackbar] = useState({
    open : false,
    message : '',
    error : false,
  })

  const isRecvOneMore = (item) => {
    for(var p of item.purchase) {
      if(p.recv_yn === 'Y') {
        return true
      }
    }

    return false
  }
  const isPurchased = (item) => {
    return Boolean(item.purchase_date)
  }

  useEffect(()=>{
    // console.log('props' , props)
    //  console.log('history ' , history)
    if (props.location.state){
      window.scrollTo(0, 0);
      // setTitle(props.location.state.products.title)
      console.log("buy ", props.location.state.buy)
      setBuy(props.location.state.buy)
    }

    return ()=>{
      console.log('back ' + history.action)
      // history.replace(history.location.pathname, {buy : 'aaa'});
      // if (history.action === "POP") {
      //
      // }
    }
  }, [])

  const closeBuyDialog = () => {
    setBuyDialog({
      open: false,
    })
  }

  const getTaxStateColor = (item) =>{

    if(item.card_tax_yn === 'Y'){
      return 'white'
    }else if(item.recv_complete === 'Y' && item.card_tax_req_yn === 'N'){
      return 'white'
    }else{
      return 'white'
    }
  }

  const getTaxStateText = (item) => {
    if(item.card_tax_req_yn === 'Y') {
      return '정산중'
    }else if(item.card_tax_yn === 'Y'){
      return '정산완료'
    }else if(item.recv_complete === 'Y' && item.card_tax_req_yn === 'N'){
      return '입고완료, 정산가능'
    }else{
      return '배송중'
    }
  }

  const setCard = (ev, name) => {
    setCardMenuAnchorEl(null)
    console.log('setCard ' + name)
    setCardName(name)

    setBuyDialog({
      ...buyDialog,
      cardError: Boolean(name) ? '' : '결제카드를 선택하세요',
      buyAvailable: ((!Boolean(buyDialog.priceError)) && Boolean(name))
    })
  }

  const cancelBuy = () => {
    const data = {}
    closeBuyDialog()
    data['purchase_cart_id'] = buy.purchase_cart_id
    data['date'] = moment(buyDialog.date).format('YYYY/MM/DD HH:mm')
    data['card'] = cardName
    data['cart_id'] = buy.cart_id
    data['total_price'] = buy.total_price
    data['purchase_price'] = buyDialog.priceTotal

    setRequesting(true)
    axios.post(`${process.env.REACT_APP_API_HOST}/osbuy/cancel`, {
      // headers: {
      //   'Content-type': 'application/x-www-form-urlencoded',
      // },
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        info: data
      }
    }).then((resp) => {

      console.log(resp)

      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
        console.log("result ", resp.data['results'])
        setBuy(resp.data['results'])

        setSnackbar({
          open: true,
          message: "구매이력이 취소되었습니다..",
          error: false,
        })
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 300){
          console.log("result ", resp.data['results'])
          setBuy(resp.data['results'])

          setSnackbar({
            open: true,
            message: "입고가 완료되어 구매이력을 취소 할 수 없습니다.",
            error: true,
          })
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
        history.replace('/signin')
      }else{
        setSnackbar({
          open: true,
          message: "구매이력 업데이트를 실패했습니다.",
          error: true,
        })
      }

      setRequesting(false)
    }).catch((e)=>{
      setSnackbar({
        open: true,
        message: "구매이력 업데이트를 실패했습니다.",
        error: true,
      })
      setRequesting(false)
    })

  }

  const postBuyComplete = () => {
    const data = {}
    closeBuyDialog()

    if(isPurchased(buy)){
      data['purchase_cart_id'] = buy.purchase_cart_id
      data['date'] = moment(buyDialog.date).format('YYYY/MM/DD HH:mm')
      data['card'] = cardName
      data['cart_id'] = buy.cart_id
      data['total_price'] = buy.total_price
      data['purchase_price'] = buyDialog.priceTotal

      setRequesting(true)
      axios.post(`${process.env.REACT_APP_API_HOST}/osbuy/update`, {
        // headers: {
        //   'Content-type': 'application/x-www-form-urlencoded',
        // },
        params: {
          token: cookie.load(RECEIVER_COOKIE_KEY),
          info: data
        }
      }).then((resp) => {

        console.log(resp)

        if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

          console.log("result ", resp.data['results'])

          setBuy(resp.data['results'])

          setSnackbar({
            open: true,
            message: "구매이력 업데이트를 성공했습니다.",
            error: false,
          })
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 300){
          console.log("result ", resp.data['results'])
          setBuy(resp.data['results'])

          setSnackbar({
            open: true,
            message: "입고가 완료되어 구매이력 업데이트할 수 없습니다.",
            error: true,
          })
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
          history.replace('/signin')
        }else{
          setSnackbar({
            open: true,
            message: "구매이력 업데이트를 실패했습니다.",
            error: true,
          })
        }

        setRequesting(false)
      }).catch((e)=>{
        setSnackbar({
          open: true,
          message: "구매이력 업데이트를 실패했습니다.",
          error: true,
        })
        setRequesting(false)
      })

    }else{

      // data['userid'] =
      data['date'] = moment(buyDialog.date).format('YYYY-MM-DD')
      data['dest'] = buy.dest
      data['memo'] = ''
      data['card'] = cardName
      data['shopname'] = buy.shop_name
      data['gsApply'] = true
      data['osRefId'] = buy.cart_id
      // data['prodList'] = []
      data['total_price'] = buy.total_price
      data['purchase_price'] = buyDialog.priceTotal

      // for(const p of buy.purchase){
      //   data['prodList'].push({
      //     id_fs : p.product_fs_id,
      //     opt_code : p.opt,
      //     name : p.name,
      //     quantity : p.count,
      //     price : p.price,
      //     link : buy.url,
      //   })
      // }

      setRequesting(true)
      axios.post(`${process.env.REACT_APP_API_HOST}/osbuy`, {
        // headers: {
        //   'Content-type': 'application/x-www-form-urlencoded',
        // },
        params: {
          token: cookie.load(RECEIVER_COOKIE_KEY),
          info: data
        }
      }).then((resp) => {

        console.log(resp)

        if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
          console.log("result ", resp.data['results'])
          setBuy(resp.data['results'])

          setSnackbar({
            open: true,
            message: "구매이력 업데이트를 성공했습니다.",
            error: false,
          })
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
          history.replace('/signin')
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 405){
          console.log("already purchased ", resp.data['results'])
          setBuy(resp.data['results'])

          setSnackbar({
            open: true,
            message: "이미 구매 완료한 상품입니다.",
            error: false,
          })
        }else{

          setSnackbar({
            open: true,
            message: "구매이력 업데이트를 실패했습니다.",
            error: true,
          })
        }

        setRequesting(false)
      }).catch((e)=>{
        setSnackbar({
          open: true,
          message: "구매이력 업데이트를 실패했습니다.",
          error: true,
        })
        setRequesting(false)
      })
    }

  }

  // const getProductBuyCond = (data, index, purchaseCond) => {
  //   if(data.buy_cond){
  //     return data.buy_cond;
  //   }
  //   if(index === 0 && purchaseCond){
  //     return purchaseCond
  //   }
  //
  //   return "결제조건없음"
  // }

  const buyCond = (data, index, purchaseCond) => {
    if(data.buy_cond){
      return <Chip
        color={"info"}
        label={data.buy_cond}
        sx={{
            fontSize: 18,
            mt: 1,
            // color : '#009900',
            // fontWeight: 'medium',
            // textDecoration : 'underline',
            // display: 'flex',
            // justifyContent: 'flex-end',
          }}
      />

      // return data.buy_cond;
    }
    if(index === 0 && purchaseCond){
      return <Chip
        color={"info"}
        label={purchaseCond}
        sx={{
            fontSize: 18,
            mt: 1,
            // color : '#009900',
            // fontWeight: 'medium',
            // textDecoration : 'underline',
            // display: 'flex',
            // justifyContent: 'flex-end',
          }}
      />
    }

    return <Box
        sx={{
            fontSize: 18,
            mt: 1,
          }}
    >
      {"결재조건 없음"}
    </Box>
  }


  return (
    <Box
     sx={{
      backgroundColor: (theme) => theme.palette.grey[100],
      width : '100%',
      height : '100vh',
      justifyContent : 'center'
     }}>
      {
        requesting ?
          <ProgressDiv>
            <CircularProgress size={34} thickness={4}/>
          </ProgressDiv>
          :
          <Fragment>
            {
              buy != null ?
              <Box
                sx={{
                  backgroundColor: (theme) => theme.palette.grey[100],
                  display: 'flex',
                  width: '100%',
                  // height : '100vh',
                  flexGrow: 1,
                  justifyContent: 'center'
                }}>
                <Box
                  sx={{
                    pt: 2,
                    pl: 2,
                    pr: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    // backgroundColor: (theme) => theme.palette.grey[100],
                    maxWidth: 480,
                    width: '100%',
                    flexGrow: 1,
                  }}
                >
                  {
                    (isPurchased(buy)) ?
                      <Paper
                        square
                        variant={"outlined"}
                        sx={{
                          backgroundColor: 'success.light',
                          color: 'white',
                          pt: 1,
                          pl: 2,
                          pr: 2,
                          pb: 1,
                          mb: 1
                        }}
                      >
                        <Box
                          sx={{
                            // textDecorationLine: ((buy.purchase_yn === 'Y') ? 'line-through' : 'none'),
                            // color: ((buy.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
                            fontWeight: 'medium',
                            mt: 1
                          }}
                        >
                          {'구매완료 ' + moment(new Date(buy.purchase_date)).format('YYYY/MM/DD HH:mm')}
                        </Box>

                        {/*<Box*/}
                        {/*  sx={{*/}
                        {/*    // textDecorationLine: ((buy.purchase_yn === 'Y') ? 'line-through' : 'none'),*/}
                        {/*    // color: ((buy.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),*/}
                        {/*    fontWeight: 'medium',*/}
                        {/*    mt: 1,*/}
                        {/*    display: 'flex',*/}
                        {/*    justifyContent: 'flex-end',*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  {*/}
                        {/*    buy.recv_yn === 'Y' ?*/}
                        {/*      '입고완료'*/}
                        {/*      :*/}
                        {/*      '입고안됨'*/}
                        {/*  }*/}

                        {/*</Box>*/}

                        <Box
                          sx={{
                            fontWeight: 'medium',
                            fontSize: 29,
                            mt: 1,
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          {buy.purchase_total_price.toLocaleString() + ' 원 결제'}
                        </Box>
                        <Box
                          sx={{
                            fontWeight: 'medium',
                            mt: 1,
                            display: 'flex',
                            // fontSize : 18,
                            justifyContent: 'flex-end',
                          }}
                        >
                          {'결제카드 - ' + buy.purchase_card_name}
                        </Box>
                        <Box
                          sx={{
                            fontWeight: 'medium',
                            mt: 1,
                            display: 'flex',
                            // fontSize : 18,
                            justifyContent: 'flex-end',
                            color : getTaxStateColor(buy)
                          }}
                        >
                          {getTaxStateText(buy)}
                        </Box>
                      </Paper>

                      :
                      <div/>
                  }
                  {/*<Paper*/}
                  {/*  square*/}
                  {/*  variant={"outlined"}*/}
                  {/*  sx={{*/}
                  {/*    fontWeight: 'medium',*/}
                  {/*    fontSize: 21,*/}
                  {/*    // backgroundColor: (theme => theme.palette.grey[200]),*/}
                  {/*    pt: 2,*/}
                  {/*    pl: 2,*/}
                  {/*    pr: 2,*/}
                  {/*    pb: 2,*/}
                  {/*  }}*/}
                  {/*>*/}
                  {/*  {getBuyCond(buy)}*/}
                  {/*</Paper>*/}
                  <Paper
                    square
                    variant={"outlined"}
                    sx={{
                      fontWeight: 'medium',
                      fontSize: 21,
                      // backgroundColor: (theme => theme.palette.grey[200]),
                      p: 2,
                      mt : 1
                    }}
                  >
                    {getWarehouseNameFromState(parseInt(buy.dest), warehouseState) + '창고'}
                  </Paper>
                  <Paper
                    square
                    variant={"outlined"}
                    sx={{
                      fontWeight: 'medium',
                      fontSize: 21,
                      // backgroundColor: (theme => theme.palette.grey[200]),
                      p: 2,
                      mt : 1
                    }}
                  >
                    {'결제금액 ' + buy.total_price.toLocaleString() + '원 이하'}
                  </Paper>
                  <Paper
                    square
                    variant={"outlined"}
                    sx={{
                      fontWeight: 'medium',
                      fontSize: 21,
                      // backgroundColor: (theme => theme.palette.grey[200]),
                      p: 2,
                      mt : 1,
                                            overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {'링크 - ' + buy.shop_name}
                  </Paper>
                  {
                    buy.purchase.map((data, index) => (
                      <Box
                        key={index}
                        sx={{
                          mt : 1,
                          display : 'flex',
                          flexDirection : 'row'
                        }}
                      >
                        <Paper
                          // key={index}
                          square
                          variant={"outlined"}
                          sx={{
                            // backgroundColor : (theme => theme.palette.grey[200]),
                            pt : 1,
                            pb : 1,
                            pl : 2,
                            pr : 2,
                            flexGrow : 1,
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: 18,
                              mt: 1
                            }}
                          >
                            {data.name}
                          </Box>
                          {buyCond(data, index, buy.cond)}
                          {/*<Box*/}
                          {/*  sx={{*/}
                          {/*    fontSize: 18,*/}
                          {/*    mt: 1,*/}
                          {/*    color : '#009900',*/}
                          {/*    fontWeight: 'medium',*/}
                          {/*    // textDecoration : 'underline',*/}
                          {/*    // display: 'flex',*/}
                          {/*    // justifyContent: 'flex-end',*/}
                          {/*  }}*/}
                          {/*>*/}
                          {/*  {getProductBuyCond(data, index, buy.cond)}*/}
                          {/*</Box>*/}

                          <Box
                            sx={{
                              // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
                              // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
                              fontWeight: 'medium',
                              fontSize: 20,
                              mt: 1,
                              display: 'flex',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {
                              Boolean(data.opt) ?
                                '옵션 ' + data.opt
                                :
                                '옵션 없음'
                            }
                          </Box>
                          <Box
                            sx={{
                              // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
                              // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
                              fontWeight: 'medium',
                              fontSize: 20,
                              mt : 0.5,
                              display: 'flex',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {data.count + '개'}
                          </Box>
                          <Box
                            sx={{
                              // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
                              color: ((isPurchased(buy) && data.recv_yn === 'Y') ?'green' : 'red'),
                              fontWeight: 'medium',
                              fontSize: 20,
                              mt: 1,
                              display: 'flex',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {
                              isPurchased(buy) ?
                                (data.recv_yn === 'Y' ? '입고됨' : '입고안됨')
                                :
                                ''
                            }
                          </Box>
                          {/*<Box*/}
                          {/*  sx={{*/}
                          {/*    // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),*/}
                          {/*    // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),*/}
                          {/*    fontWeight: 'medium',*/}
                          {/*    fontSize: 24,*/}
                          {/*    // mt : 1,*/}
                          {/*    display: 'flex',*/}
                          {/*    justifyContent: 'flex-end',*/}
                          {/*  }}*/}
                          {/*>*/}
                          {/*  {data.price.toLocaleString() + '원'}*/}
                          {/*</Box>*/}
                        </Paper>
                        {
                          (Boolean(data.shop_url) && (data.shop_url.startsWith('http') || data.shop_url.startsWith('https')))?
                            <Link style={{textDecorationLine : 'none',}} to={{pathname: data.shop_url}} target={"_blank"}>
                              <Button
                                disabled={!Boolean(data.shop_url)}
                                sx={{
                                  borderRadius : 0,
                                  // outlineWidth : 0,
                                  // mt: 1,
                                  // mb: 1,
                                  height : '100%'
                                }}
                                color={'secondary'}
                                variant={"contained"}
                              >
                                {'구매'}
                              </Button>
                            </Link>
                            :
                              <Button
                                disabled={true}
                                sx={{
                                  borderRadius : 0,
                                  // outlineWidth : 0,
                                  // mt: 1,
                                  // mb: 1,
                                  height : '100%'
                                }}
                                color={'info'}
                                variant={"contained"}
                              >

                              </Button>
                        }

                      </Box>
                    ))
                  }
                  <Box sx={{height: 80}}/>
                </Box>
                <Paper sx={{position: 'fixed', bottom: 0, left: 0, right: 0}} elevation={3}>
                  <Button
                    disabled={buy.card_tax_yn === 'Y' || buy.card_tax_req_yn === 'Y' || (isPurchased(buy) && isRecvOneMore(buy))}
                    fullWidth
                    variant={"contained"}
                    color={isPurchased(buy) ? "error" : 'primary'}
                    sx={{
                      pt: 2,
                      pb: 2,
                      fontSize: 16,
                      borderRadius: 0,
                      // width : '100%',
                    }}
                    onClick={() => {
                      setCardName(buy.purchase_card_name)
                      let cardError = ''
                      let selectCardAvailable = true;
                      if(Boolean(userState.data.data.card_list)){
                        if(buy.purchase_card_name == null) {
                          cardError = '결제카드를 선택하세요'
                        }
                      }else{
                        cardError = '등록된 결제 카드가 없습니다. [메인->우측상단마이->카드관리]에서 결제카드를 등록해주세요'
                        selectCardAvailable = false
                      }
                      setBuyDialog({
                        open: true,
                        date: buy.purchase_date != null ? new Date(buy.purchase_date) : new Date(),
                        cardError: cardError,
                        priceTotal:(isPurchased(buy) ? buy.purchase_total_price : buy.total_price),
                        selectCardAvailable : selectCardAvailable,
                        buyAvailable : isPurchased(buy)
                      })
                    }}
                  >
                    {isPurchased(buy) ?
                      "수정"
                      :
                      "구매완료"
                    }
                  </Button>
                </Paper>

                <Dialog
                  // fullWidth
                  // maxWidth={maxWidth}
                  open={buyDialog.open}
                  // onClose={()=>closeBuyDialog()}
                  onClose={()=>{}}
                >
                  {/*<DialogTitle>구매한 내용을 입력 해주세요</DialogTitle>*/}
                  <DialogContent>
                    <DialogContentText>
                      구매한 내용을 입력 해주세요
                    </DialogContentText>
                    <Box
                      noValidate
                      component="form"
                      sx={{
                        mt: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        // m: 'auto',
                        width: '100%',
                      }}
                    >
                      <Box sx={{mb : 1}}>
                        <Typography variant={"body2"}>구매 날짜</Typography>
                      </Box>
                      <MobileDateTimePicker
                        okText={"설정"}
                        cancelText={"취소"}
                        toolbarTitle={"입고시간을 설정하세요"}
                        value={buyDialog.date}
                        onChange={(newValue) => {
                          setBuyDialog({...buyDialog, date : newValue});
                        }}
                        // label="With error handler"
                        // onError={console.log}
                        // minDate={new Date('2018-01-01T00:00')}
                        inputFormat="yyyy/MM/DD hh:mm a"
                        mask="___/__/__ __:__ _M"
                        renderInput={(params) => <TextField {...params} />}
                      />
                      <Box sx={{mt : 2, mb : 1}}>
                        <Typography variant={"body2"}>가격</Typography>
                      </Box>
                      {/*<TextField type={"number"} label="" variant="outlined" />*/}
                      <CurrencyTextField
                        allowNegativeValue={false}
                        id="input-example"
                        name="input-name"
                        placeholder=""
                        defaultValue={buyDialog.priceTotal}
                        onValueChange={(value, name) => {

                          const price = parseInt(value)
                          let error = ''
                          console.log( value + ' ' + price )
                          if(!Boolean(price) || isNaN(price) || price === undefined){
                            error = '구매가격이 입력되지 않았습니다.'
                          }else if(price > buy.total_price){
                            error = '구매가격은 요청가격을 넘을수 없습니다.'
                          }else if(parseInt(value) === 0){
                            error = '구매가격은 0이 될수 없습니다.'
                          }

                          setBuyDialog({
                            ...buyDialog,
                            priceTotal: value,
                            priceError: error,
                            buyAvailable: (!Boolean(error) && Boolean(cardName))
                          })
                        }}
                      />
                      <Box sx={{mt : 0.5, mb : 1, fontSize : 14, color : 'error.light'}}>
                        {buyDialog.priceError}
                      </Box>
                      <Box sx={{mt : 2, mb : 1}}>
                        <Typography variant={"body2"}>결제카드</Typography>
                      </Box>

                      <Button
                        // sx={{flexGrow : 1}}
                        // style={{height: 50, minWidth: 80}}
                        // type={"button"}
                        // aria-multiline={false}
                        disabled={!buyDialog.selectCardAvailable}
                        onClick={(event)=>{
                          setCardMenuAnchorEl(event.target)
                        }}
                        fullWidth={true}
                        variant={"outlined"}
                        endIcon={<ArrowDropDownOutlined/>}
                      >
                        {cardName}
                      </Button>
                      <Box sx={{mt : 0.5, mb : 1, fontSize : 14, color : 'error.light'}}>
                        {buyDialog.cardError}
                      </Box>
                      <Menu
                        id="card-menu"
                        anchorEl={cardMenuAnchorEl}
                        anchorOrigin={{horizontal : 'center', vertical : 'bottom'}}
                        open={cardMenuOpen}
                        onClose={()=>{setCardMenuAnchorEl(null)}}
                      >
                        {
                          (userState != null && userState.data != null
                            && userState.data.data != null && userState.data.data.card_list != null)?
                            userState.data.data.card_list.split('/').map((card, index) =>
                            <MenuItem
                              key={index}
                              sx={{flexGrow: 1, width: '100%'}}
                              onClick={(ev) => setCard(ev, card)}>
                              {card}
                            </MenuItem>
                            )
                            :
                            <div/>
                        }
                      </Menu>
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant={"outlined"}
                      onClick={()=>closeBuyDialog()}
                    >
                      닫기
                    </Button>
                    {
                      isPurchased(buy) ?
                        <Button
                          variant={"contained"}
                          color={'error'}
                          onClick={()=>cancelBuy()}
                        >
                          구매취소
                        </Button>
                        :
                        <div/>
                    }
                    <Button
                      variant={"contained"}
                      color={'success'}
                      disabled={!buyDialog.buyAvailable}
                      onClick={()=>postBuyComplete()}>
                      확정
                    </Button>
                  </DialogActions>

                </Dialog>
              </Box>
              :
              <div/>
            }
          </Fragment>
      }
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={()=>setSnackbar({open : false, message: ''})}
      >
        <Alert sx={{width : '100%'}} severity={snackbar.error ? "error" : "success"}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  )
}